import { render, staticRenderFns } from "./data-downlink-transmission-modal.vue?vue&type=template&id=5116e5e0"
import script from "./data-downlink-transmission-modal.vue?vue&type=script&lang=js"
export * from "./data-downlink-transmission-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports